import { rem } from "polished";
import styled from "styled-components";

import { withViewportStyle } from "@/components/editor/shared/with-viewport-style";
import { ColorLabels } from "@/components/editor/utils/use-color";

export const Wrapper = styled.div`
  color: #fff;
  background-color: ${({ theme }) => theme.colors[ColorLabels.BACKGROUND]};
  position: relative;
`;

export const CTAButtonWrapper = withViewportStyle("div")`
  padding: 0 ${rem(24)} 0;
  white-space: nowrap;

  .button-primitive {
    font-weight: 600;
    font-size: ${rem(15)};
    line-height: ${rem(28)};
    padding: ${rem(8)} ${rem(40)};
    background: ${({ theme }) => theme.colors[ColorLabels.PRIMARY]};
    color: ${({ theme }) => theme.colors[ColorLabels.BACKGROUND]};

    ${(props) => props.$viewport.mobile`
      font-size: ${rem(12)};
      padding-top: 0;
      padding-bottom: 0;
    `}
  }
`;
